import * as React from "react";
import {connect} from "react-redux";
import User from "../../../../model/user/User";
import {none, option, Option} from "ts-option";
import Lead from "../../../../model/lead/Lead";
import {updateLeadAssignees} from "../../../../store/action/lead/lead";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import BDPSelector from "./BDPSelector";

interface IComponentProps {
	/**
	 * Selected business development partner id.
	 */
	businessDevelopmentPartnerId: Option<string>;
	/**
	 * On bdp change callback.
	 * @param {User} user
	 */
	onChange?: (user: User) => void;
	/**
	 * Indicate if selection is removable (shows "x" button).
	 */
	removable?: boolean;
	/**
	 * On delete icon click callback. If not set, it will remove BDP for lead.
	 * @param {React.MouseEvent<HTMLSpanElement>} evt
	 */
	onRemoveClick?: (evt: React.MouseEvent<HTMLSpanElement>) => void;
}

export default class LeadBDPSelector extends React.PureComponent<IComponentProps, {}> {
	constructor(props: IComponentProps) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.onRemoveClick = this.onRemoveClick.bind(this);
	}

	render() {
		return (
			<BDPSelector removable={this.props.businessDevelopmentPartnerId.isDefined && this.props.removable}
						 onChange={this.onSelect}
						 onRemoveClick={this.onRemoveClick}
						 businessDevelopmentPartnerId={this.props.businessDevelopmentPartnerId}/>
		);
	}

	onSelect(user: User) {
		if (this.props.onChange) {
			this.props.onChange(user);
		}
	}

	onRemoveClick(evt: React.MouseEvent<HTMLSpanElement>) {
		if (this.props.removable && this.props.onRemoveClick) {
			return this.props.onRemoveClick(evt);
		}
		return null;
	}
}